import type { Attachment } from '@tadpoles/common'

export function getRemoteAttachmentKey(attachment: Attachment): string | undefined {
    return [attachment.key, attachment.originKey].find((key) => key && !key.startsWith('L.'))
}
